import { useSelector } from "react-redux";

const useOrgId = () => {
  const orgId = useSelector((state: any) => {
    const permissions = state.userData?.permissions as
      | undefined
      | { organizationId?: string }[];

    return permissions?.find((x) => x.organizationId)?.organizationId;
  });
  return orgId;
};

export default useOrgId;
